export default {
	ConnectInvoices: [],
	ConnectInvoicesTotal: 0,
	ConnectInvoicesTaxaxion: [],
	ConnectInvoicesTaxaxionTotal: 0,
	InvoicesAutoLoad: [],
	TaxCodeCQT: null,
	ConnectOutInvoices: [],
	ConnectOutInvoicesTotal: 0,
	OutInvoicesAutoLoad: [],
	DataConnectTaxaxion: null,
	DataConnectSupplier: null, // Danh sách nhà cung cấp đã kết nôi
	IsLoadingTotalRecords: false,
	IsLoadingTotalTypeInvoice: false,
	IsLoadingTotalInvoiceStatus: false,
	TotalTypeInvoiceAutoLoad: {},
	NumberInvoiceAutoRespone: {},
	ConnectInvoiceDetails: [],
	ConnectOutInvoiceDetails: [],
	TimeServerRemind: {},
	TotalInvoiceStatus: {
		All: 0,
		Success: 0,
		Fail: 0,
		Processed: 0,
		Processing: 0,
		Duplicated: 0,
		Ignore: 0
	},
	TotalOutInvoiceStatus: {
		All: 0,
		Success: 0,
		Fail: 0,
		Processed: 0,
		Processing: 0,
		Duplicated: 0,
		Ignore: 0
	},
	isShowFormDisconnectActive: false, // Biến lưu trạng thái form mất kết nối với CQT
	isShowFormConnectActive: false, // Biến lưu trạng thái form kết lại với CQT
	IsLoadingTotalRecordsInbot: false,
	IsLoadingTotalRecordsOutbot: false,
	//Danh sách hóa đơn đang tải từ CQT (tab đầu vào — PBI 625836)
	InvoiceLoadingList: [],
	InvoiceLoadingTotal: 0,
	IsLoadingInvoiceLoading: false,
	OutInvoiceLoadingList: [],
	OutInvoiceLoadingTotal: 0,
	IsLoadingOutInvoiceLoading: false
};
